// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
import SvgIconStyle from '../../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name: string) => (
  <SvgIconStyle src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  booking: getIcon('ic_booking'),
  invoice: getIcon('ic_invoice'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  menuItem: getIcon('ic_menu_item'),
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'Maxwell',
    items: [{ title: 'Assess', path: PATH_DASHBOARD.maxwell.assess, icon: ICONS.dashboard }],
  },
  {
    subheader: 'Account',
    items: [
      { title: 'Profiles', path: PATH_DASHBOARD.calendar, icon: ICONS.blog },
      { title: 'Scan History', path: PATH_DASHBOARD.user.history, icon: ICONS.calendar },
      { title: 'Analytics', path: PATH_DASHBOARD.calendar, icon: ICONS.analytics },
      { title: 'Account Settings', path: PATH_DASHBOARD.calendar, icon: ICONS.mail },
      { title: 'Help Center', path: PATH_DASHBOARD.calendar, icon: ICONS.ecommerce },
    ],
  },
];

export default navConfig;
